"use client"

import * as React from "react"
import { CaretSortIcon, CheckIcon } from "@radix-ui/react-icons"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"   

interface DataProps {
    value: string
    label: string
}
interface PropsCombobox {
  data: DataProps[],
  title: string,
  titleSelect: string,
  getSelectData?: (data: string) => void,
  width?: string
  defaultValue?: string
}
export function Combobox({data, title, titleSelect, getSelectData, width = 'w-[240px]', defaultValue = ''}: PropsCombobox) {
  const [open, setOpen] = React.useState(false)
  const [value, setValue] = React.useState(defaultValue)

  React.useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="justify-between w-full truncate "
        >
          {value
            ? data.find((item) => item.value == value.toLocaleUpperCase())?.label
            : titleSelect} 
          <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={`${width} p-0`}>
        <Command>
          <CommandInput placeholder="Pesquisar..." className="h-9" />
          <CommandList>
            <CommandEmpty>{title}</CommandEmpty> 
            <CommandGroup>
              {data.map((item) => (
                <CommandItem
                  key={item.value}
                  value={item.value}
                  onSelect={(currentValue) => {
                    const nextValue = currentValue.toLocaleUpperCase() === value.toLocaleUpperCase()
                      ? ""
                      : currentValue.toLocaleUpperCase()
                    setValue(nextValue)
                    getSelectData?.(nextValue)
                    setOpen(false) 
                  }}
                >
                  {item.label}
                  <CheckIcon
                    className={cn(
                      "ml-auto h-4 w-4",
                      item.value == value.toLocaleUpperCase() ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup> 
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
